import { SpaceProps } from 'styled-system'

export enum BadgeVariant {
  PENDING = 'pending',
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning'
}

export const variants = {
  PENDING: { variant: BadgeVariant.PENDING, title: 'Something is pending' },
  ERROR: { variant: BadgeVariant.ERROR, title: 'Something went wrong' },
  SUCCESS: { variant: BadgeVariant.SUCCESS, title: 'Something went well' },
  WARNING: { variant: BadgeVariant.WARNING, title: 'Warning' }
} as const

export interface BadgeProps extends SpaceProps {
  title: string
  variant: BadgeVariant
  customPadding?: string
}
